import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { navItems, findMeLinks } from '../data/mockData';
import { LiveClock, StatusIndicator } from './LiveClock';

// Tiny color/hat preview shown next to nav item on hover (easter egg)
// const tipPreviews = {
//   '/home': { swatches: ['#e8d5b7', '#fde2e4', '#1a2a5e', '#fce8e8'] },
//   '/about': { swatches: ['#fce8d4', '#a8d8e8', '#d4b896'] },
//   '/sketchbook': { swatches: ['#f3f1eb', '#e8e4d8'] },
//   '/visitor-gallery': { swatches: ['#e8a5a8', '#e8b88a', '#7eb8b8', '#9bc28a'] },
// };

// function NavTip({ swatches }) {
//   return (
//     <div className="sb-nav-tip bg-cream-50 border border-cream-300/70 rounded-md p-1.5 shadow-lg flex gap-1">
//       {swatches.map((c, i) => (
//         <span key={i} className="w-4 h-4 rounded-sm" style={{ background: c }} />
//       ))}
//     </div>
//   );
// }

export default function Sidebar() {
  const location = useLocation();
  return (
    <aside className="w-[280px] shrink-0 border-r border-cream-300/50 flex flex-col px-7 py-8 h-screen sticky top-0">
      <Link to="/" className="sb-logo block mb-5 reveal-up">
        <svg width="42" height="42" viewBox="0 0 42 42" className="text-inkwell-900 hover-wiggle">
          <g>
            <path d="M21 6 L23 14 L31 16 L23 18 L21 26 L19 18 L11 16 L19 14 Z" fill="#e8a55a" />
            <circle cx="33" cy="10" r="2" fill="#7eb8b8" />
            <circle cx="10" cy="30" r="2.5" fill="#e8a5a8" />
            <rect x="30" y="28" width="3" height="3" fill="#5a7faf" transform="rotate(45 31.5 29.5)" />
          </g>
        </svg>
      </Link>

      <h1 className=" text-[34px] leading-none text-inkwell-1200 reveal-up stagger-1">Manisha Pundir</h1>
      <p className=" text-[11px] uppercase tracking-wider text-inkwell-500 mt-2 reveal-up stagger-2">Product Design Lead @ RhythmQ</p>

      <p className="text-[13.5px] text-inkwell-700 mt-5 mb-5 leading-relaxed reveal-up stagger-3">
        I am a designer who loves building delightful software that solves real problems.
      </p>

      <div className="flex justify-end -my-1 mr-2">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" className="float-y">
          <path d="M12 22 V14 M12 14 C12 10 8 8 6 8 C6 12 8 14 12 14 M12 14 C12 10 16 8 18 8 C18 12 16 14 12 14" stroke="#5a8a4a" strokeWidth="1.5" strokeLinecap="round" fill="#9bc28a" fillOpacity="0.4"/>
        </svg>
      </div>

      <div data-platform="true" className="mt-3 bg-cream-200/60 rounded-md p-2 border border-cream-300/60 reveal-up stagger-4">
        <p className=" text-[10.5px] uppercase tracking-wider text-inkwell-500 px-2 pt-1 pb-2">Explore</p>
        <nav className="flex flex-col">
          {navItems.map((item, idx) => {
            const active = location.pathname === item.path;
            // const tip = tipPreviews[item.path];
            return (
              <Link
                key={item.no}
                to={item.path}
                style={{ animationDelay: `${0.28 + idx * 0.06}s` }}
                className={`sb-nav-row reveal-up flex items-center justify-between px-2 py-1.5 rounded text-[12.5px] ${active ? 'is-active bg-cream-100 text-inkwell-900' : 'text-inkwell-700'}`}
              >
                {/* <span className="sb-nav-dot" /> */}
                <span className="flex items-center gap-2">
                  <span className="text-inkwell-500">{item.no}.</span>
                  <span>{item.label}</span>
                  {item.badge && <span className="w-1.5 h-1.5 rounded-full animate-pulse" style={{ backgroundColor: 'var(--visitor-accent)' }} />}
                </span>
                <span className="sb-arrow">→</span>
                {/* {tip && <NavTip swatches={tip.swatches} />} */}
              </Link>
            );
          })}
        </nav>
      </div>

      <div className="mt-7 reveal-up stagger-7">
        <p className=" text-[10.5px] uppercase tracking-wider text-inkwell-500">Find Me At</p>
        <p className="text-[13px] text-inkwell-700 mt-2">
          {findMeLinks.map((l, i) => (
            <React.Fragment key={l.label}>
              <a href={l.href} target="_blank" rel="noopener noreferrer" className="link-underline">{l.label}</a>
              {i < findMeLinks.length - 1 && ', '}
            </React.Fragment>
          ))}
        </p>
      </div>

      <div className="mt-auto reveal-up stagger-8">
        <LiveClock className="text-[11.5px] text-inkwell-700 block" />
        <StatusIndicator className="mt-1" />
      </div>
    </aside>
  );
}
